import request from "./../utils/request";

export function getInvoices(filters = {}, paginationCursor = {}) {
    return request({
        url: `/billing/pagination`,
        method: "get",
        params: {
            ...filters,
            pageCount: paginationCursor.page || 1,
            perPage: paginationCursor.perPage || 20,
        },
    });
}

export function getInvoiceById(invoiceId) {
    return request({
        url: `/billing/invoice/${invoiceId}`,
    }).then((res) => res.data);
}

export function getAllInvoicesPaginated(
    siteId,
    price,
    paid,
    refund,
    perPage = 20,
    page = 1,
    startDate = null,
    endDate = null
) {
    return request({
        url: `/billing/all/pagination`,
        method: "get",
        params: {
            siteId,
            price,
            paid,
            refund,
            perPage,
            page,
            startDate,
            endDate,
        },
    });
}

export function getInvoicesBySiteId(siteId, perPage = 20, pageCount = 1) {
    return request({
        url: `/billing/custom/pagination`,
        method: "get",
        params: {
            pageCount,
            perPage,
            siteId,
        },
    });
}

export function updateCardInfo({ alias, holderName, cardNumber, expireMonth, expireYear }) {
    return request({
        url: "/billing/change-credit-card",
        method: "post",
        data: {
            alias,
            holderName,
            cardNumber,
            expireMonth,
            expireYear,
        },
    });
}

export function updateBilling({
    billingType,
    name,
    surname,
    email,
    identityNumber,
    billingCountry,
    billingCity,
    billingAddress,
    billingContactName,
    taxOffice,
    taxNumber,
}) {
    return request({
        url: "/billing/update-billing-detail",
        method: "post",
        data: {
            billingType,
            name,
            surname,
            email,
            identityNumber,
            billingCountry,
            billingCity,
            billingAddress,
            billingContactName,
            taxOffice,
            taxNumber,
        },
    });
}

export function createPaymentMethod(paymentMethodPayload) {
    return request({
        url: `/billing/create-payment-method`,
        method: "post",
        data: {
            ...paymentMethodPayload,
        },
    });
}

export function getBillingDetail() {
    return request({
        url: "/billing/get-billing-detail",
        method: "get",
    });
}

export function takePayment(invoiceId) {
    return request({
        url: "/billing/get-payment",
        method: "post",
        data: {
            invoiceId,
        },
    });
}

export function createInvoice(price, description, createdDate, additionalData = {}) {
    return request({
        url: "/billing/",
        method: "post",
        data: {
            price,
            description,
            createdDate,
            ...additionalData,
        },
    });
}

export function updateInvoiceById(invoiceId, payload) {
    return request({
        url: `/billing/${invoiceId}`,
        method: "post",
        data: payload,
    });
}

export function delInvoice(invoiceId) {
    return request({
        url: "/billing/" + invoiceId,
        method: "delete",
    });
}

export function forceDeleteInvoice(siteId, invoiceId) {
    return request({
        url: "/billing/force-delete-invoice",
        method: "post",
        data: {
            siteId,
            invoiceId,
        },
    });
}

export function refundInvoice(invoiceId) {
    return request({
        url: "/billing/" + invoiceId,
        method: "patch",
    });
}

export function getPayment(id, data) {
    return request.put(`/welcomeMessages/${id}`, data);
}

export function changeShopifyPlan(plan, agentCount) {
    return request({
        url: "/billing/shopify/change-plan",
        method: "post",
        data: { plan, agentCount },
    });
}

export function changePlan(plan, agentCount) {
    return request({
        url: "/billing/change-plan",
        method: "post",
        data: { plan, agentCount },
    });
}

export function shopifyPlanApproved(chargeId) {
    return request({
        url: "/billing/shopify/plan-approved",
        method: "post",
        data: { chargeId },
    });
}

export function markInvoiceAsPaid(siteId, invoiceId) {
    return request({
        url: "/billing/mark-invoice-as-paid",
        method: "POST",
        data: { siteId, invoiceId },
    });
}

export function updateIntegration(planId, status, period = "monthly") {
    return request({
        url: "/billing/update-integration",
        method: "POST",
        data: { planId, status, period },
    });
}

export function subscribePlan(planId, period = "monthly", details, couponCode) {
    return request({
        url: "/billing/update-integration",
        method: "POST",
        data: {
            planId,
            period,
            details,
            couponCode,
            status: true,
        },
    }).then((res) => res.data);
}

export function subscribePlanBySiteId(siteId, planId, period = "monthly", details) {
    return request({
        url: `/billing/${siteId}/update-integration`,
        method: "POST",
        data: {
            planId,
            period,
            details,
            status: true,
        },
    }).then((res) => res.data);
}

export function unsubscribePlan(planId, immediateCancel) {
    return request({
        url: "/billing/update-integration",
        method: "POST",
        data: {
            planId,
            immediateCancel,
            status: false,
        },
    }).then((res) => res.data);
}

export function unsubscribePlanBySiteId(siteId, planId, immediateCancel) {
    return request({
        url: `/billing/${siteId}/update-integration`,
        method: "POST",
        data: {
            planId,
            immediateCancel,
            status: false,
        },
    }).then((res) => res.data);
}

export function runningInvoice(onlyPrice) {
    return request({
        url: `/billing/running-invoice`,
        method: "get",
        params: {
            onlyPrice,
        },
    }).then((res) => res.data);
}

export function extraSubscription(planType, subscription) {
    return request({
        url: `/billing/extra-subscription`,
        method: "post",
        data: {
            planType,
            subscription,
        },
    }).then((res) => res.data);
}

export function startPaymentWorker() {
    return request({
        url: `/billing/manuel-start/payment-worker`,
        method: "post",
    });
}

export function startInvoiceWorker() {
    return request({
        url: `/billing/manuel-start/invoice-worker`,
        method: "post",
    });
}

export function getExtraSubscription() {
    return request.get(`billing/extra-subscription`).then((res) => res.data);
}

export function applyCouponCode(couponCode) {
    return request
        .post(`billing/apply-coupon`, {
            couponCode,
        })
        .then((res) => res.data);
}
